export function handleResponse (response) {
  const data = response.data
  if (response.status >= 400) {
    const error = (data && data.message) || response.statusText
    return Promise.reject(error)
  }

  if (typeof (response.data) === 'undefined') {
    return response
  }

  return response.data
}
